<template>
  <div class="row">
    <!-- {{roomDetail}} -->
    <!-- {{contactIdArr}} -->
    <!-- {{ selectedContact }} -->
    <div class="col-sm-12 col-md-12">
      <!-- <div class="form-group"> -->
      <multiselect v-model="selectedContact" id="ajax" label="name" track-by="id" :placeholder="''" :multiple="true"
        :custom-label="customLabel" :options="contactOptions" :searchable="true" :loading="isLoading"
        :internal-search="false" :close-on-select="false" :options-limit="3" :limit="3" :limit-text="limitText"
        :max-height="600" :show-no-results="true" @search-change="asyncFind" :taggable="true" @tag="addTag"
        @select="dispatchSelectOption" @remove="remove">
        <template slot="tag" slot-scope="{ option, remove }">
          <span class="custom__tag">
            <span>{{ option.name }}</span>
            <span class="custom__remove" @click="remove(option)">❌</span>
          </span>
        </template>
        <template slot="clear" slot-scope="props">
          <div class="multiselect__clear" v-if="selectedContact.length"
            @mousedown.prevent.stop="clearAll(props.search)"></div>
        </template>
        <span slot="noResult">Oops! No elements found.</span>
      </multiselect>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  components: {
    Multiselect
  },
  props: {
    textReplyId: {
      type: String,
      default: '',
    },
    isNotifTextReply: {
      type: Number,
      default: 0,
    },
    getWhatsappNumberFromJid: {
      type: Function
    },
    roomDetail: {
      type: Object,
      default: 0,
      default: function () {
        return {
          id: "",
          room_photo: "",
          room_number: ""
        };
      }
      // required: true
    }
  },
  data() {
    return {
      tagIdArr: [], //untuk menampung tag id
      notifTagIdArr: [],//untu menampung nomor hp notif
      isSending: false,
      currentConditions: [],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        is_notif_text_reply: this.isNotifTextReply,
        page: 0,
        perPage: 20
      },
      isLoading: false,
      contactParam: {
        phone: "",
        auto_create: true, //otomatis dibuat jika data tidak ditemukan
        detail: {
          email: "",
          provider: "whatsapp",
          phone_number: "",
          first_name: "",
          phone_number_group: "",
          is_group: 0
        }
      },
      contactIdArr: []
    };
    //  isactive : true
  },
  computed: {
    textReplyTagIdNotif() {
      return this.$store.state.automation.textReplyTagIdNotif;
    },
  },
  watch: {
    textReplyTagIdNotif: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          this.selectedContact = [];
          //for tag id
          if (this.is_notif_text_reply != 1) {
            // console.log("oldVal", oldVal);
            // console.log("val", val);
            if (typeof val != "undefined" && val != "") {
              let jsonTag = JSON.parse(val)
              if (typeof jsonTag === 'object') {
                // console.log('objec', jsonTag)
                let param={
                 tags_id:jsonTag.map(i => {return {id:i}}),
                }
                this.getTagDetailByTagsId(param);
              }
            }
          }
        }
      },
      // deep: true
    }
  },
  created() {
    // this.asyncFind("");
  },
  methods: {
    validationTagSelected() {
      // console.log("optionSelected:", optionSelected);
      if (this.selectedContact.length > 3) { // only splice array when item is found
        this.selectedContact.splice(0, 1); // 2nd parameter means remove one item only
      }
    },
    getTagDetailByTagsId(param) {
      this.selectedContact = [];
      this.isLoading = true;
      // let param = {
      //   tags_id: this.tagIdArr
      // };
      this.$store
        .dispatch("crm/getTagDetailByTagsId", param)
        .then(response => {
          this.isLoading = false;
          // this.contactOptions = response.data.data;
          if (response.data != null) {
            this.selectedContact = response.data;
          }
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    async remove(tag) {
      console.log("remove", tag)
      var that = this
      await setTimeout(function () {
        that.$root.$emit("updateTagNotif", that.selectedContact);
      }, 100)


      // await this.contactIdArr.forEach((row, index) => {
      //   let paramContactId = row.id;
      //   this.isLoading = true;
      //   let param = {
      //     tag_id: tag.id,
      //     contact_id: paramContactId
      //   };
      //   this.$store
      //     .dispatch("crm/unassignFromOneTag", param)
      //     .then(response => {
      //       this.isLoading = false;
      //     }) // sesuai kan dengan method di API
      //     .catch(error => {
      //       this.isLoading = false;
      //     });
      // });

      // if (this.selectedContact.length == 0) {
      //   this.contactIdArr.forEach((row, index) => {
      //     let idContact = row.id;
      //     if (index == 0) {
      //       this.getTagDetailByContactId(idContact);
      //       // this.isLoading = true;
      //     }
      //   });
      // }
    },
    async dispatchSelectOption(optionSelected) {
      // if (
      //   this.contactIdArr == null ||
      //   this.contactIdArr.length == 0 ||
      //   this.contactIdArr == ""
      // ) {
      //   return false;
      // }

      // this.contactIdArr.forEach((row, index) => {
      //   let tagIdArr = [];
      //   // console.log("rowww", row);
      //   let idTag = optionSelected.id;
      //   let idContact = row.id;
      //   tagIdArr.push(idTag.toString());

      //   let formParam = {
      //     id: idContact.toString(),
      //     room_id: this.roomDetail.id,
      //     tag_id: tagIdArr
      //   };
      //   this.$store
      //     .dispatch("crm/assignContactToTag", formParam)
      //     .then(response => {
      //       // var { data } = response;
      //       this.isSending = false;
      //     })
      //     .catch(() => {
      //       this.isSending = false;
      //     });
      // });
      await this.validationTagSelected()
      await this.$root.$emit("updateTagNotif", this.selectedContact);

    },
    async addTag(newTag) {
      // console.log("newTag", newTag);
      // console.log("selectedCont", this.selectedContact);
      let formParam = {
        id: "",
        name: newTag,
        description: "",
        is_notif_text_reply: this.isNotifTextReply
      };
      this.isSending = await true;

      //jika notif, maka wajibkan hanya number
      if (this.isNotifTextReply == 1) {
        if (isNaN(newTag)) {
          // error
          this.$fire({
            title: "Error",
            text: "Nomor WA yang diinput belum sesuai",
            type: "error",
            timer: 1000
          }).then(r => { });
          // console.log("Please enter Numeric value");
          return false;
        } else if (newTag.length < 10) {
          // error
          this.$fire({
            title: "Error",
            text: "Nomor WA minimal 10 karakter",
            type: "error",
            timer: 1000
          }).then(r => { });
          // console.log("Please enter Numeric value");
          return false;
        }

        formParam.is_notif_text_reply = this.isNotifTextReply
      }
      await this.$store
        .dispatch("crm/createTag", formParam)
        .then(response => {
          var { data } = response;
          this.isSending = false;
          this.selectedContact.push(data);
          // this.contactOptions.push(data);

          // if(this.isNotifTextReply!=1){
          //   this.tagIdArr.push(data)
          // } else{
          //   //jika notif
          //   this.notifTagIdArr.push(data)
          // }

          //add tag
          // this.contactIdArr.forEach((row, index) => {
          //   let tagIdArr = [];
          //   let idTag = data.id;
          //   let idContact = row.id;
          //   tagIdArr.push(idTag.toString());

          //   let formParam = {
          //     id: idContact.toString(),
          //     room_id: this.roomDetail.id,
          //     tag_id: tagIdArr
          //   };
          //   // this.$store
          //   //   .dispatch("crm/assignContactToTag", formParam)
          //   //   .then(response => {
          //   //     // var { data } = response;
          //   //     this.isSending = false;
          //   //   })
          //   //   .catch(() => {
          //   //     this.isSending = false;
          //   //   });
          // });
        })
        .catch(() => {
          this.isSending = false;
        });

      this.validationTagSelected()
      this.$root.$emit("updateTagNotif", this.selectedContact);

      // console.log("tagIdArr", this.tagIdArr);
      // console.log("notifTagIdArr", this.notifTagIdArr);

    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.is_notif_text_reply = 0

      if (this.isNotifTextReply == 1) {
        this.contactListParam.is_notif_text_reply = 1
      }

      this.$store
        .dispatch("crm/listTags", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    }
  },
  mounted() { },
  name: "tagsAssign"
};
</script>


// WEBPACK FOOTER //
// src/views/ai/workflow/components/tagsAssignNotif.vue